module.exports = __webpack_public_path__ + "static/media/IMG_0937.4d8f1e42.jpg";